import React, { Fragment, useEffect, useState } from 'react';
import { connect } from "react-redux";
import Sidebar from './../Sidebar';
import ContactSearch from '../ContactBook/ContactSearch';
import Swal from "sweetalert2";
import { requestRawOutwardSave } from "../../Redux/actions";
import { bindActionCreators } from "redux";
import { Modal, ModalBody, ModalHeader, Row } from "reactstrap";

import {
    Box,
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper
} from '@mui/material';
import ContactAdd from './../ContactBook/ContactAdd';
import StoreSearch from '../Store/StoreSearch';

const initialTableData = {
    client: '',
    items: [],
    contact: null
};

function RawOutwardAdd(props) {
    const [cartData, setCartData] = useState(initialTableData);
    const [selectedTable, setSelectedTable] = useState('');
    const [selectedContact, setSelectedContact] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [products, setProducts] = useState(null);
    const [userToken, setUserToken] = useState(0);
    const [updated, setUpdated] = useState(false);
    const [addmodal, setaddModal] = useState(false);
    const [errorCategory, seterrorCategory] = useState("");
    const [errorDescription, seterrorDescription] = useState("");
    const [errorTaxRate, seterrorTaxRate] = useState("");
    const [errorCutOff, seterrorCutOff] = useState("");
    const [errorHSN, seterrorHSN] = useState("");
    const [logindetails, setlogindetails] = useState({});
    const [billdata, setBillData] = useState({
        outDate: "", remark: ""
    });

    const onchangeadddata = (event) => {
        setBillData((adddata) => ({
            ...adddata,
            [event.target.name]: event.target.value,
        }));
    };

    const [adddata, setadddata] = useState({
        category: "", description: "", shortName: "", taxRate: 0, cutOff: 5, hsn: ""
    });

    function deletedata(idToDelete) {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                const tableKey = `RawOutward_${selectedContact.custId}`;
                const storedData = JSON.parse(localStorage.getItem(tableKey)) || {};

                // 🛡️ Safe fallback if products don't exist
                const currentProducts = Array.isArray(storedData.products) ? storedData.products : [];

                // 🔍 Remove only the product with the matching id
                const updatedProducts = currentProducts.filter(item => item.id !== idToDelete);
                setProducts(updatedProducts);
                // 🧩 Preserve other table data
                const updatedTableData = {
                    ...storedData,              // Keeps contact, tableNo, etc.
                    products: updatedProducts  // Replaces only the products array
                };

                // 💾 Save back to localStorage
                localStorage.setItem(tableKey, JSON.stringify(updatedTableData));

                // 🔄 Update UI
                // setProductList(updatedProducts);
                setCartData(prev => ({ ...prev, items: updatedProducts }));
            }
        })
    }

    useEffect(() => {
        if (selectedProduct) {
            if (selectedContact === null) {
                Swal.fire({
                    title: 'Error!',
                    text: 'Select Contact first.',
                    icon: 'error'
                });
            } else {
                const current = Array.isArray(products) ? products : [];
                const exists = current.some(p => p.id === selectedProduct.id);
                if (exists) return;

                const newItem = {
                    id: selectedProduct.id,
                    item_name: selectedProduct.description,
                    qty: 1,
                    remark: selectedProduct.remark
                };

                const updated = [...current, newItem];

                // 🧩 Save to localStorage
                const dataToSave = {
                    products: updated,
                    contact: selectedContact,
                    billInfo: billdata
                };

                localStorage.setItem(`RawOutward_${selectedContact.custId}`, JSON.stringify(dataToSave));

                // 🧠 Update all relevant states
                setProducts(updated);
                setCartData(prev => ({ ...prev, items: updated }));
                setSelectedProduct(null); // use null instead of empty array to avoid logic collisions
            }
        }
    }, [selectedProduct]);

    function saveCartToApi() {
        setUpdated(true);
        props.requestRawOutwardSave({
            data: {
                userToken: userToken,
                compToken: localStorage.getItem("companyToken"),
                custId: selectedContact.custId,
                cartDatas: products,
                outDate: billdata.outDate, remark: billdata.remark
            },
        });
    }

    useEffect(() => {
        let savePurchaseData = props.data.saveRawOutwardData;
        if (savePurchaseData !== undefined && updated) {
            if (savePurchaseData?.data?.status === 1) {
                Swal.fire({
                    title: 'Good job!',
                    text: 'Cart saved successfully.',
                    icon: 'success'
                });
                setUpdated(false);
                props.data.saveRawOutwardData = undefined;
                localStorage.removeItem(`RawOutward_${selectedContact.custId}`);
            } else {
                Swal.fire({
                    title: 'Error',
                    text: savePurchaseData?.data?.message || 'Failed to update cart.',
                    icon: 'error'
                });
            }
        }
    }, [props.data.saveRawOutwardData]);

    const handleQtyChange = (id, field, value) => {
        const updatedList = products.map(item => {
            if (item.id !== id) return item;

            const updatedItem = { ...item, [field]: value };

            return updatedItem;
        });

        setProducts(updatedList);
        updateTables(updatedList); // ✅ pass the updated array
    };

    function updateTables(updatedProducts) {
        console.log(updatedProducts);
        const updatedTableData = {
            products: updatedProducts,
            contact: selectedContact,
            billInfo: billdata
        };

        // Update state
        setProducts(updatedProducts);
        setCartData(prev => ({ ...prev, items: updatedProducts }));

        // Save to localStorage
        localStorage.setItem(`RawOutward_${selectedContact.custId}`, JSON.stringify(updatedTableData));
    }

    const onchangeaddstore = (event) => {
        setadddata((adddata) => ({
            ...adddata,
            [event.target.name]: event.target.value,
        }));
    };

    const addtoggle = () => setaddModal(!addmodal);

    const saveaddtoggle = (e) => {
        e.preventDefault();
        if (validateAddForm()) {
            let data1 = JSON.parse(localStorage.getItem("user"));
            props.requestStoreSave({
                data: {
                    userToken: data1.data.userToken,
                    //      compToken: localStorage.getItem('companyToken'),
                    compToken: '611337539322',
                    category: adddata.category,
                    description: adddata.description,
                    quantity: adddata.quantity,
                    freeQty: adddata.freeQty,
                    shortName: adddata.shortName,
                    hsn: adddata.hsn,
                    warranty: adddata.warranty,
                    taxRate: adddata.taxRate
                },
            });
            setadddata({
                category: "", description: "", quantity: 0, freeQty: 0, barcode: "", hsn: "", warranty: 0, taxRate: 0
            });
            addtoggle();
        }
    };

    useEffect(() => {
        let addData = props.data.storeSaveData;
        if (addData !== undefined) {
            if (addData.data.status === 1) {
                console.log(addData.data.status);
                Swal.fire({
                    title: "Good job!",
                    text: addData.data.message,
                    icon: "success",
                });
            }
        }
        props.data.storeSaveData = undefined;
        addData = undefined;
    }, [props.data.storeSaveData]);

    function validateAddHSN() {
        let formIsValid = false;
        if (!adddata.hsn) {
            formIsValid = false;
            seterrorHSN("*Enter HSN.");
        } else if (!/^\d{3}$/.test(adddata.hsn)) {
            formIsValid = false;
            seterrorHSN("*Enter valid HSN.");
        } else {
            formIsValid = true;
            seterrorHSN("");
        }
        return formIsValid;
    }

    function validateAddCutOff() {
        let formIsValid = false;
        const str = String(adddata.cutOff);  // Convert to string

        if (!str) {
            seterrorCutOff("*Enter cut off.");
        } else if (!/^\d{1,3}$/.test(str)) {
            seterrorCutOff("*Enter valid cut off (1 to 3 digits).");
        } else {
            formIsValid = true;
            seterrorCutOff("");
        }
        return formIsValid;
    }

    function validateAddTaxRate() {
        let formIsValid = false;
        const taxRateStr = String(adddata.taxRate);  // Convert to string

        if (!taxRateStr) {
            seterrorTaxRate("*Enter tax rate.");
        } else if (!/^\d{1,3}$/.test(taxRateStr)) {
            seterrorTaxRate("*Enter valid tax rate (1 to 3 digits).");
        } else {
            formIsValid = true;
            seterrorTaxRate("");
        }

        return formIsValid;
    }

    function validateAddCategory() {
        let formIsValid = false;
        if (!adddata.category) {
            formIsValid = false;
            seterrorCategory("*Enter Category.");
        } else {
            formIsValid = true;
            seterrorCategory("");
        }
        return formIsValid;
    }

    function validateAddDescription() {
        let formIsValid = false;
        if (!adddata.description) {
            formIsValid = false;
            seterrorDescription("*Enter Description.");
        } else {
            formIsValid = true;
            seterrorDescription("");
        }
        return formIsValid;
    }

    function validateAddForm() {
        let hsn = validateAddHSN(); let cutoff = validateAddCutOff(); let taxRate = validateAddTaxRate(); let category = validateAddCategory(); let description = validateAddDescription();
        let valid = hsn && cutoff && taxRate && category && description;
        if (!valid) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Please fill all the required fields correctly.",
            });
        }
        return valid;
    }

    return (
        <Fragment>
            <div class="container-scroller">
                {/* <PageHeader name="Jobs" /> */}
                <div class="container-fluid page-body-wrapper">
                    <Sidebar name="Jobs" />
                    <div class="main-panel">
                        <div class="content-wrapper">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="home-tab">
                                        <div class="row flex-grow">
                                            <div class="grid-margin stretch-card">
                                                <div class="card card-rounded">
                                                    <div class="row card-body">
                                                        <div class="col-md-6 card mb-3">
                                                            <div class="card-body">
                                                                <div className="row">
                                                                    <div className='col-md-6'><input type="date" name='outDate' className="form-control" placeholder="Date" onChange={onchangeadddata}></input></div>
                                                                    <div className='col-md-6'><input type="text" name='remark' className="form-control" placeholder="Remark" onChange={onchangeadddata}></input></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="card mb-3">
                                                            <div class="row card-body form-fields">
                                                                <div className='col-md-4'><StoreSearch onStoreelect={(p) => setSelectedProduct(p)}></StoreSearch></div>
                                                                <button className='badge badge-opacity-warning' style={{ width: "50px" }}><i className='fa fa-plus'></i></button>
                                                                {addmodal === true && (
                                                                    <Modal
                                                                        isOpen={addmodal}
                                                                        toggle={addtoggle}
                                                                    >
                                                                        <ModalHeader toggle={addtoggle}>
                                                                            Update Product
                                                                        </ModalHeader>
                                                                        <ModalBody>
                                                                            <form class="forms-sample">
                                                                                <div class="form-group">
                                                                                    <label>Category</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        class="form-control"
                                                                                        placeholder="Category"
                                                                                        name="category"
                                                                                        value={adddata.category}
                                                                                        onBlur={validateAddCategory}
                                                                                        onChange={onchangeadddata}
                                                                                    />
                                                                                    {errorCategory && <p>{errorCategory}</p>}
                                                                                </div>
                                                                                <div class="form-group">
                                                                                    <label>Short Name</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        class="form-control"
                                                                                        placeholder="ShortName"
                                                                                        name="shortName"
                                                                                        value={adddata.shortName}
                                                                                        onChange={onchangeadddata}
                                                                                    />
                                                                                </div>
                                                                                <div class="form-group">
                                                                                    <label>Description</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        class="form-control"
                                                                                        placeholder="Description"
                                                                                        name="description"
                                                                                        value={adddata.description}
                                                                                        onBlur={validateAddDescription}
                                                                                        onChange={onchangeadddata}
                                                                                    />
                                                                                    {errorDescription && <p>{errorDescription}</p>}
                                                                                </div>
                                                                                <div class="form-group">
                                                                                    <label>Tax Rate</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        class="form-control"
                                                                                        placeholder="Tax Rate"
                                                                                        name="taxRate"
                                                                                        value={adddata.taxRate}
                                                                                        onBlur={validateAddTaxRate}
                                                                                        onChange={onchangeadddata}
                                                                                    />
                                                                                    {errorTaxRate && <p>{errorTaxRate}</p>}
                                                                                </div>
                                                                                <div class="form-group">
                                                                                    <label>Cut Off</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        class="form-control"
                                                                                        placeholder="Cut Off"
                                                                                        name="cutOff"
                                                                                        value={adddata.cutOff}
                                                                                        onBlur={validateAddCutOff}
                                                                                        onChange={onchangeadddata}
                                                                                    />
                                                                                    {errorCutOff && <p>{errorCutOff}</p>}
                                                                                </div>
                                                                                <div class="form-group">
                                                                                    <label>HSN</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        class="form-control"
                                                                                        placeholder="hsn"
                                                                                        name="hsn"
                                                                                        value={adddata.hsn}
                                                                                        onBlur={validateAddHSN}
                                                                                        onChange={onchangeadddata}
                                                                                    />
                                                                                    {errorHSN && <p>{errorHSN}</p>}
                                                                                </div>
                                                                                <button
                                                                                    type="submit" class="btn btn-primary me-2" onClick={saveaddtoggle} >
                                                                                    Save
                                                                                </button>
                                                                                <button
                                                                                    class="btn btn-light"
                                                                                    onClick={addtoggle}
                                                                                >
                                                                                    Cancel
                                                                                </button>
                                                                            </form>
                                                                        </ModalBody>
                                                                    </Modal>
                                                                )}

                                                            </div>
                                                        </div>
                                                        <div class="card mb-3">
                                                            <div class="row card-body form-fields">
                                                                <Box sx={{ overflowX: 'auto' }}>
                                                                    <TableContainer component={Paper} sx={{ maxHeight: 300 }}>
                                                                        <Table stickyHeader size="small">
                                                                            <TableHead>
                                                                                <TableRow>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>#</TableCell>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>Item Name</TableCell>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>Qty</TableCell>
                                                                                    <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>Remark</TableCell>
                                                                                </TableRow>
                                                                            </TableHead>
                                                                            <TableBody>
                                                                                {Array.isArray(products) ? products.map((item, index) => (
                                                                                    <TableRow
                                                                                        key={index}
                                                                                        hover
                                                                                        sx={{
                                                                                            cursor: 'pointer',
                                                                                            backgroundColor: index % 2 === 0 ? 'white' : '#f5f5f5' // Light gray for odd rows
                                                                                        }}
                                                                                    >
                                                                                        <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>{index + 1}</TableCell>
                                                                                        <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}>{item.item_name || '—'}</TableCell>
                                                                                        <TableCell>
                                                                                            <input
                                                                                                type="number"
                                                                                                min="1"
                                                                                                value={item.qty}
                                                                                                onChange={(e) => handleQtyChange(item.id, 'qty', parseFloat(e.target.value))}
                                                                                                style={{ width: '60px', padding: '4px' }}
                                                                                            />
                                                                                        </TableCell>
                                                                                        <TableCell>
                                                                                            <input
                                                                                                type="number"
                                                                                                min="1"
                                                                                                value={item.discper}
                                                                                                onChange={(e) => handleQtyChange(item.id, 'remark', e.target.value)}
                                                                                                style={{ width: '160px', padding: '4px' }}
                                                                                            />
                                                                                        </TableCell>
                                                                                        <TableCell sx={{ fontSize: { xs: '0.8rem', sm: '1rem' }, px: { xs: 1, sm: 2 } }}><button class="badge badge-opacity-danger" style={{ border: "0px", background: "#fea8a9", marginLeft: "5px", }}
                                                                                            onClick={() => { deletedata(item.id); }}><i class="fa fa-trash"></i></button></TableCell>
                                                                                    </TableRow>
                                                                                )) : ""}
                                                                            </TableBody>
                                                                        </Table>
                                                                    </TableContainer>
                                                                </Box>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <button onClick={() => {
                                if (selectedTable !== '') {
                                    setTables({ ...tables, [selectedTable]: cartData });
                                    alert('Data saved for table: ' + selectedTable);
                                }
                            }}>Save Table Data</button> */}
                            <div
                                style={{
                                    position: 'sticky',
                                    bottom: 0,
                                    width: '100%',
                                    background: '#fff',
                                    boxShadow: '0 -2px 5px rgba(0,0,0,0.1)',
                                    padding: '1rem',
                                    zIndex: 99
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        flexWrap: 'wrap'
                                    }}
                                >
                                    <button
                                        className="btn btn-primary"
                                        onClick={() => { saveCartToApi() }}
                                    >
                                        Save Outward
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

const mapStateToProps = (state) => {
    return { data: state.data };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ requestRawOutwardSave }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RawOutwardAdd);